import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import ConfirmDialog from 'scenes/IO/components/ConfirmDialog';
import { GetIOEntityName } from 'scenes/IO/helpers';
import { signAgreementWithNoChanges } from 'scenes/IO/sources/io';

import { markAsAgreement } from '../queryKeyFactory';

export const useMarkAsAgreementWithNoChangesIo = (io) => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const entityName = GetIOEntityName(io);
  const markAsAgreementMutation = useMutation(
    markAsAgreement(),
    signAgreementWithNoChanges,
    {
      successMessage: () => `${entityName} marked as "Agreement"`,
    }
  );
  const handleMarkAsAgreement = async () => {
    const { id } = io;
    await showModal({
      title: `Mark ${entityName} as Agreement with no changes?`,
      io: io,
      confirmActionLabel: 'Mark as Agreement',
    });

    await markAsAgreementMutation.mutateAsync({ id });
  };

  return [handleMarkAsAgreement, markAsAgreementMutation];
};
